import { render, staticRenderFns } from "./hotPicksPop.vue?vue&type=template&id=9bf333b6&scoped=true"
import script from "./hotPicksPop.vue?vue&type=script&lang=js"
export * from "./hotPicksPop.vue?vue&type=script&lang=js"
import style0 from "./hotPicksPop.vue?vue&type=style&index=0&id=9bf333b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf333b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bf333b6')) {
      api.createRecord('9bf333b6', component.options)
    } else {
      api.reload('9bf333b6', component.options)
    }
    module.hot.accept("./hotPicksPop.vue?vue&type=template&id=9bf333b6&scoped=true", function () {
      api.rerender('9bf333b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/hotPicksPop.vue"
export default component.exports